export default "__VITE_ASSET__CY0wO2yp__"